import request from '@/axios/storeManager'

// 01-获取门店列表
export function getStoreList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/getStoreList',
    method: 'post',
    data
  })
}

// 02-获取员工详情
export function getStaffDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff/getStaffDetail',
    method: 'post',
    data
  })
}

// 03-切换当前门店
export function changeStore(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/changeStore',
    method: 'post',
    data
  })
}
// YW-市场-01-市场数据概览
export function getBazaarVisitInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getBazaarVisitInfo',
    method: 'post',
    data
  })
}

// 工作台-01-业务数据概览
export function getOverviewInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getOverviewInfo',
    method: 'post',
    data
  })
}
// YW-市场-02-上门数据分布
export function getBazaarInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getBazaarInfo',
    method: 'post',
    data
  })
}

// 工作台-02-业务完成情况
export function getAccomplishInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getAccomplishInfo',
    method: 'post',
    data
  })
}
// YW-销售-01-销售数据概览
export function getMarketInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMarketInfo',
    method: 'post',
    data
  })
}
// YW-销售-02-客户经理上门数据
export function getMarketVisitList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMarketVisitList',
    method: 'post',
    data
  })
}
// YW-销售-03-销售排行榜
export function getMarkeRankingList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMarkeRankingList',
    method: 'post',
    data
  })
}

// 工作台-03-当月经营数据
export function getMonthManageInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMonthManageInfo',
    method: 'post',
    data
  })
}
// YW-销售-07-退单排行
export function getMarkeReturnRankingList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMarkeReturnRankingList',
    method: 'post',
    data
  })
}
// YW-销售-04-行为合格率分析
export function getMarkeQualifiedList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMarkeQualifiedList',
    method: 'post',
    data
  })
}

// YW-退单-01-退单数据概览
export function getReturnInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager_invalid/getReturnInfo',
    method: 'post',
    data
  })
}
// YW-销售-05-转化率周期分析
export function getMarkeChangeList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMarkeChangeList',
    method: 'post',
    data
  })
}

// YW-退单-02-退单原因分析
export function getReturnCauseList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager_invalid/getReturnCauseList',
    method: 'post',
    data
  })
}
// YW-销售-06-数据警告
export function getMarkeWarningInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getMarkeWarningInfo',
    method: 'post',
    data
  })
}

// YW-退单-03-退单面积占比
export function getReturnAreaList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager_invalid/getReturnAreaList',
    method: 'post',
    data
  })
}
// YW-设计-01-设计数据概览
export function getDesignInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getDesignInfo',
    method: 'post',
    data
  })
}

// YW-退单-04-退单阶段占比
export function getReturnStageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager_invalid/getReturnStageList',
    method: 'post',
    data
  })
}
// YW-设计-02-设计排行
export function getDesignRankingList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getDesignRankingList',
    method: 'post',
    data
  })
}
// YW-设计-06-退单排行
export function getDesignReturnRankingList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getDesignReturnRankingList',
    method: 'post',
    data
  })
}
// YW-设计-03-行为合格率分析
export function getDesignQualifiedList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getDesignQualifiedList',
    method: 'post',
    data
  })
}
// YW-设计-04-合同签约周期
export function getDesignSignList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getDesignSignList',
    method: 'post',
    data
  })
}
// YW-设计-05-数据警告
export function getDesignWarningInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getDesignWarningInfo',
    method: 'post',
    data
  })
}

// YW-退单-05-数据警告
export function getReturnWarningInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager_invalid/getReturnWarningInfo',
    method: 'post',
    data
  })
}
// PM-02-工程部经理问题工地统计
export function getProblemSiteCount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/project_manager/getProblemSiteCount',
    method: 'post',
    data
  })
}
// PM-03-工程部经理问题类型统计
export function getProblemTypeCount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/project_manager/getProblemTypeCount',
    method: 'post',
    data
  })
}
// 工作台-04-待处理事项
export function getTodoItem(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getTodoItem',
    method: 'post',
    data
  })
}
// 15-预上门客户列表
export function preCustomerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/preCustomerList',
    method: 'post',
    data
  })
}
// (新)P-01-(店长)分配预上门
export function preVisitAllocation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/manager_pad/explain_function/preVisitAllocation',
    method: 'post',
    data
  })
}
export function getStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/getStaffList',
    method: 'post',
    data
  })
}
export function preVisitHandover(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/manager_pad/explain_function/preVisitHandover',
    method: 'post',
    data
  })
}

// CM-08-门店客户经理列表
export function storeManagerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/managerList',
    method: 'post',
    data
  })
}

// 01-派单策略提交
export function saveDispatchStrategy(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager_dispatch/saveDispatchStrategy',
    method: 'post',
    data
  })
}

// 03-员工持单情况列表
export function getHolderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getHolderList',
    method: 'post',
    data
  })
}

// 04-今天到店情况列表
export function getTodayVisitList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getTodayVisitList',
    method: 'post',
    data
  })
}

// 11-店长批量转单
export function saveBatchTransfer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/saveBatchTransfer',
    method: 'post',
    data
  })
}

// 05-获取服务岗位类型列表
export function getStationList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getStationList',
    method: 'post',
    data
  })
}

// 13-店长催办
export function press(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/press',
    method: 'post',
    data
  })
}

// 06-获取服务岗位员工列表
export function getStationStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getStationStaffList',
    method: 'post',
    data
  })
}

// 12-店长转单
export function saveTransfer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/saveTransfer',
    method: 'post',
    data
  })
}

// 08-员工状态列表
export function getJobStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getJobStatus',
    method: 'post',
    data
  })
}

// 09-提交员工状态
export function saveStaffStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/saveStaffStatus',
    method: 'post',
    data
  })
}

// 14-获取门店派单策略
export function getDispatchStrategy() {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager_dispatch/getDispatchStrategy',
    method: 'post'
  })
}
// 公海池客户列表
export function getCustomerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/opportunity/getCustomerList',
    method: 'post',
    data
  })
}
// 门店客户经理列表
export function getManagerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/manager/getManagerList',
    method: 'post',
    data
  })
}
// 公海池面谈分配
export function saveAwaitVisit(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/opportunity/saveAwaitVisit',
    method: 'post',
    data
  })
}
// 公海池预面谈列表
export function getAwaitVisitList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/manager/getAwaitVisitList',
    method: 'post',
    data
  })
}
// 06-公海池面谈转单
export function saveHighTransfer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/manager/saveTransfer',
    method: 'post',
    data
  })
}
// 05-公海池客户详情
export function getCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/manager/getCustomerInfo',
    method: 'post',
    data
  })
}

// 1502-(new)预上门时间筛选
export function getTimeTypes(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/getTimeTypes',
    method: 'post',
    data
  })
}

// (new)16-事业部门店列表
export function getDepartmentStoreList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getDepartmentStoreList',
    method: 'post',
    data
  })
}

// 17-获取预上门客户信息
export function getPreCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/getPreCustomerInfo',
    method: 'post',
    data
  })
}

// (new)17-预上门分配门店
export function allocationStore(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/allocationStore',
    method: 'post',
    data
  })
}

/**
 * 保存员工状态（增加日志）（0304）
 */
export function saveAllStaffStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/saveAllStaffStatus',
    method: 'post',
    data
  })
}
